
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': 'Általános',
	'widgetId': 'Felületi elem azonosítója',
	'widgetType': 'Felületi elem típusa',
	'serviceability': 'Javíthatóság',
	'copyButton': 'Másolás',
	'closeButton': 'Bezárás',
	'specification': 'Specifikációk',
	'viewSpecification': 'Specifikáció megjelenítése'
});
